import React from "react"
import { Articles } from "../data/articles"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import Menu from "./menu"
import CategoryLink from "./category-link"

export default () => (
  <div id="footer-wrap">
    <div id="footer">
      <div id="recent-posts-3" className="quick-links widget_recent_entries">
        <h5>Recent Posts</h5>
        <ul>
          {Articles.getLatest(5).map(article => (
            <li key={article.link}>
              <AniLink fade to={article.link}>
                {article.title}
              </AniLink>
            </li>
          ))}
        </ul>
      </div>
      <div id="linkcat-2" className="quick-links widget_links">
        <h5>Categories</h5>
        <ul className="xoxo blogroll">
          {Articles.getUniqueCategories(5).map(cat => (
            <li key={cat}>
              <CategoryLink cat={cat} />
            </li>
          ))}
        </ul>
      </div>
      <div id="text-2" className="quick-links widget_text email">
        <h5>get in touch</h5>
        <div className="textwidget">
          <p>
            you can write to me at: <br /> mihai at mihaidoru dot ro
          </p>
        </div>
      </div>
      <div id="text-3" className="quick-links widget_text social-links">
        <h5> stay connected</h5>
        <div className="textwidget">
          <a
            className="facebook"
            href="http://www.facebook.com/mihaidoru.ro"
            target="_blank"
            rel="noopener noreferrer"
          >
            facebook
          </a>
          <a
            className="twitter"
            href="https://twitter.com/mihaidoru"
            target="_blank"
            rel="noopener noreferrer"
          >
            twitter
          </a>
          <a
            className="linkedin"
            href="http://www.linkedin.com/in/mihaidoru"
            target="_blank"
            rel="noopener noreferrer"
          >
            linkedin
          </a>
        </div>
      </div>
      <div className="last-footer">
        <div className="copy">
          copyright &copy; {new Date().getFullYear()} <span>GetFresh.</span> all
          rights reserved.
        </div>
        <div className="menu-footer-menu-container">
          <Menu menuId="footermenu" />
        </div>
      </div>
    </div>
  </div>
)
